"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when encrypted tutoring form param is invalid
 */
class InvalidEncryptedTutoringFormError extends client_library_1.ExtendableError {
    constructor() {
        super(`Invalid encrypted tutoring form param provided`);
    }
}
exports.default = InvalidEncryptedTutoringFormError;
//# sourceMappingURL=InvalidEncryptedTutoringFormError.js.map